import React from "react";

function JIOSaavn(props) {
	return (
		<div className="height-100">
			<iframe
				src="https://www.jiosaavn.com/embed/playlist/933503632"
				frameBorder="0"
				height="100%"
				width="100%"
				title="Jio Saavn"
			></iframe>
		</div>
	);
}

export default JIOSaavn;
